import {Component, effect, inject, Signal} from '@angular/core';
import {
  IApiRow,
  IGroupMap,
  INITIAL_STATE_TOKEN,
  ITableVerticalDataGroup,
  TableVerticalControlComponent,
} from 'frontier/index';
import {MatProgressBar} from "@angular/material/progress-bar";
import {ProcessOverviewStore} from "../../service/process-overview.store";
import AppControlGuids from "../../../../../api/ControlGuids";
import {ICart} from "../../service/state.interface";
import {
  TableVerticalControlCoreComponent
} from "frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control-core/table-vertical-control-core.component";

@Component({
  selector: 'kpi4me-client-detail',
  templateUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.html',
  styleUrl: '../../../../../../../projects/frontier/browserkit/src/lib/components/control/table-vertical-control/table-vertical-control.component.scss',
  standalone: true,
  imports: [MatProgressBar, TableVerticalControlCoreComponent],
  providers: [
    {provide: INITIAL_STATE_TOKEN, useValue: {filter: null}}
  ],
})
export class ClientDetailComponent extends TableVerticalControlComponent {
  private _processOverviewService: ProcessOverviewStore = inject(ProcessOverviewStore);

  override GUID: string = AppControlGuids.TClientList;

  override groupMap = {
    'Person': [0, 1, 2, 3],
    'Adresse': [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
    'Versicherung': [16, 17, 18, 19, 20, 21, 22, 23, 24]
  }

  private selectedCart: Signal<ICart> = this._processOverviewService.selectedCart;

  override mapRow(row: IApiRow, groupMap: IGroupMap = this.groupMap): ITableVerticalDataGroup[] {
    if (row.cols[8].value === false) {
      for (const hiddenIdx of [9, 10, 11, 12, 13, 14, 15]) {
        row.cols[hiddenIdx].hidden = true
      }
    }
    // "Befreit bis" (NoClientChargeUntil) nur relevant, wenn "Zuzahlungsbefreit" (NoClientCharge) aktiv ist
    if (row.cols[23]?.value === false && row.cols[24]) {
      row.cols[24].hidden = true
    }
    return super.mapRow(row, groupMap)
  }

  constructor() {
    super();
    effect(() => {
      const selectedCart: ICart = this.selectedCart();
      if (selectedCart) {
        this.patchFilter({
          parent: selectedCart.obj
        });
      }
    }, {allowSignalWrites: true});
  }
}
